/** Estilos CSS de rotación / espejo para elementos imagen (element.style). */
export function getImageElementTransformStyle(style = {}) {
	const rotationRaw = Number(style?.imageRotation);
	const rotation = Number.isFinite(rotationRaw) ? rotationRaw : 0;
	const flipX = !!style?.imageFlipX;
	const flipY = !!style?.imageFlipY;
	const parts = [];
	if (rotation) parts.push(`rotate(${rotation}deg)`);
	if (flipX) parts.push("scaleX(-1)");
	if (flipY) parts.push("scaleY(-1)");
	if (!parts.length) return {};
	return { transform: parts.join(" "), transformOrigin: "center center" };
}

export function hasImageElementTransform(style = {}) {
	const rotationRaw = Number(style?.imageRotation);
	return (Number.isFinite(rotationRaw) && rotationRaw !== 0) || !!style?.imageFlipX || !!style?.imageFlipY;
}
